export const emojis = {
  celebration: "🎉",
  danger: "👎",
  heart: "❤️",
  hello: "👋",
  loveEyesFace: "😍",
  neutralFace: "😐",
  notFound: "😫",
  sadFace: "😞",
  success: "👏",
  warning: "😣",
  confused: "😕",
  slightlySmile: "🙂",
};
